import { render, staticRenderFns } from "./Headerprintsetting.vue?vue&type=template&id=46fa9109&scoped=true&"
import script from "./Headerprintsetting.vue?vue&type=script&lang=js&"
export * from "./Headerprintsetting.vue?vue&type=script&lang=js&"
import style0 from "./Headerprintsetting.vue?vue&type=style&index=0&id=46fa9109&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa9109",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fa9109')) {
      api.createRecord('46fa9109', component.options)
    } else {
      api.reload('46fa9109', component.options)
    }
    module.hot.accept("./Headerprintsetting.vue?vue&type=template&id=46fa9109&scoped=true&", function () {
      api.rerender('46fa9109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Headers/Headerprintsetting.vue"
export default component.exports